import React from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import Downloads from './components/Downloads';
import { DownloadsProvider } from './contexts/DownloadsContext';

import './styles/downloads.css'
import { detectOS } from './js/downloads-utility';

type Props = {}

const defaultOS = detectOS();
const params = new URLSearchParams(window.location.search);

export default function App({}: Props) {
    const queryClient = new QueryClient();
  return (
    <div>
        <DownloadsProvider defaultOS={defaultOS} params={params}>
            <QueryClientProvider client={queryClient}>
                <Downloads />
            </QueryClientProvider>
        </DownloadsProvider>
    </div>
  )
}